import gql from 'graphql-tag';

export const fetchCatalogsQuery = gql `
  query SearchCatalogs {
    catalog {
      id
      name
    }
    defaultCatalog: catalog(where: { is_active: { _eq: true } }) {
      id
      name
    }
  }
`;

export const fetchCountDifferentBuyerQueryFilter = gql `
  query GetDifferentBuyerViews($from: timestamptz!, $to: timestamptz!) {
    item_visits_aggregate(where: {created_at: {_gte: $from}, _and: {created_at: {_lt: $to}}}) {
      aggregate {
        count(distinct: true, columns: organization_tax)
      }
    }
  }
`;

export const fetchCountItemViewsQueryFilter = gql `
  query GetItemsViews($from: timestamptz!, $to: timestamptz!) {
    item_visits_aggregate(where: {created_at: {_gte: $from}, _and: {created_at: {_lt: $to}}}) {
      aggregate {
        count
      }
    }
  }
`;
export const fetchCountDifferentBuyerQuery = gql `
  query GetDifferentBuyerViews {
    item_visits_aggregate {
      aggregate {
        count(distinct: true, columns: organization_tax)
      }
    }
  }
`;

export const fetchCountItemViewsQuery = gql `
  query GetItemsViews {
    item_visits_aggregate {
      aggregate {
        count
      }
    }
  }
`;

export const fetchCountItemMatchQuery = gql `
  query GetItemsMatch {
    item_match_aggregate {
      aggregate {
        count
      }
    }
  }
`;

export const fetchCountDifferentItemMatchQuery = gql `
  query GetItemsMatch {
    item_match_aggregate(distinct_on: item_id) {
      aggregate {
        count
      }
    }
  }
`;

export const fetchCatalogItemsQuery = gql `
  query SearchCatalogItems
  (
    $limit: Int!, 
    $offset: Int!, 
    $keyword: String, 
    $published_at_is_null: Boolean,
    $price_gte: numeric,
    $price_lte: numeric,
  ) {
    search_item_aggregate(
      where: {
        _and: {
          catalog: { is_active: { _eq: true } },
          published_at: {_is_null: $published_at_is_null},
          price: { _gte: $price_gte, _lte: $price_lte}
        }
      }
      args: { search: $keyword }
    ) {
      aggregate {
        count
      }
    }
    search_item(
      where: {
        _and: {
          catalog: { is_active: { _eq: true } },
          published_at: {_is_null: $published_at_is_null},
          price: { _gte: $price_gte, _lte: $price_lte}
        }
      }
      args: { search: $keyword }
      limit: $limit
      offset: $offset
    ) {
      id
      sku
      name
      description
      currency
      price
      uom
      manufacturer
      manufacturer_partnumber
      published_at
      category_id
      image
    }
  }
`;

export const fetchCatalogItemQuery = gql `
  query CatalogItemById($productId: uuid!) {
    item_by_pk(id: $productId) {
      id
      sku
      code
      name
      description
      catalog_id
      currency
      price
      uom
      manufacturer
      manufacturer_partnumber
      published_at
      has_stock
      is_obsolete
      is_active
      category_id
      taxonomy_category {
        mdm_code
        mdm_name
      }
      noun
      modifier
      item_attribute_values {
        item_id
        attribute_id
        mdm_value
        taxonomy_attribute {
          mdm_code
          mdm_name
          mdm_order
          is_required
        }
      }
      technical_specification
      image
    }
  }
`;

export const fetchCatalogItemsStatistics = gql `query {
  published_items: item_aggregate(where: { published_at: { _is_null: false }}){
    aggregate {
      count
    }
  }
  unpublished_items: item_aggregate(where: { published_at: { _is_null: true }}){
    aggregate{
      count
    }
  }
  actived_users: user_aggregate(where: { locked_at: { _is_null: true }}){
    aggregate {
      count
    }
  }
}`;



// WEBPACK FOOTER //
// ./src/store/graphql/queries/catalog.js